(() => {
  if (window.PMCollectionHeaderScrollInitialized) {
    document.dispatchEvent(new Event('collection-header-scroll:refresh'));
    return;
  }

  window.PMCollectionHeaderScrollInitialized = true;

  const triggerSelector = '[data-collection-header-scroll-trigger="true"]';
  const toolbarSelector = '[data-collection-toolbar]';
  const enabledClass = 'collection-header-hide-enabled';
  const hiddenClass = 'collection-header-hidden';
  const focusableSelector = 'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])';
  const revealBuffer = 12;

  let trigger = null;
  let observer = null;
  let resizeObserver = null;
  let triggerTop = 0;
  let ticking = false;
  let resizeTimer = null;

  const getHeaderSections = () => ({
    announcement: document.querySelector('.announcement-banner-section'),
    header: document.querySelector('.section-header')
  });

  const getSectionHeight = (element) => (element ? element.getBoundingClientRect().height : 0);

  const getToolbar = () => document.querySelector(toolbarSelector);

  const syncHeights = () => {
    const { announcement, header } = getHeaderSections();
    const toolbar = getToolbar();
    const announcementHeight = getSectionHeight(announcement);
    const headerHeight = getSectionHeight(header);
    const toolbarHeight = getSectionHeight(toolbar);
    const headerOffset = announcementHeight + headerHeight;

    document.documentElement.style.setProperty('--collection-announcement-height', `${announcementHeight}px`);
    document.documentElement.style.setProperty('--collection-header-offset', `${headerOffset}px`);
    document.documentElement.style.setProperty('--collection-toolbar-height', `${toolbarHeight}px`);

    if (headerHeight > 0) {
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    }

    return headerOffset;
  };

  const setSectionInert = (element, isHidden) => {
    if (!element) return;

    element.toggleAttribute('aria-hidden', isHidden);

    if ('inert' in element) {
      element.inert = isHidden;
      return;
    }

    element.querySelectorAll(focusableSelector).forEach((item) => {
      if (isHidden) {
        if (item.hasAttribute('tabindex')) {
          item.dataset.collectionHeaderOriginalTabindex = item.getAttribute('tabindex');
        }
        item.setAttribute('tabindex', '-1');
      } else if (item.dataset.collectionHeaderOriginalTabindex !== undefined) {
        item.setAttribute('tabindex', item.dataset.collectionHeaderOriginalTabindex);
        delete item.dataset.collectionHeaderOriginalTabindex;
      } else {
        item.removeAttribute('tabindex');
      }
    });
  };

  const setHidden = (isHidden) => {
    const wasHidden = document.body.classList.contains(hiddenClass);
    if (wasHidden === isHidden) return;

    document.body.classList.toggle(hiddenClass, isHidden);

    const { announcement, header } = getHeaderSections();
    setSectionInert(announcement, isHidden);
    setSectionInert(header, isHidden);

    if (isHidden) {
      const stickyHeader = document.querySelector('sticky-header');
      stickyHeader?.closeMenuDisclosure?.();
      stickyHeader?.closeSearchModal?.();
    }

    window.dispatchEvent(new Event('resize'));
  };

  const measureTrigger = () => {
    if (!trigger) return;

    syncHeights();
    triggerTop = window.pageYOffset + trigger.getBoundingClientRect().top;
  };

  const update = () => {
    ticking = false;
    if (!trigger) return;

    syncHeights();

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const isHidden = document.body.classList.contains(hiddenClass);
    const shouldHide = isHidden ? scrollTop >= triggerTop - revealBuffer : scrollTop >= triggerTop;

    setHidden(shouldHide);
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  const refresh = () => {
    if (!trigger) return;

    measureTrigger();
    requestUpdate();
  };

  const setupObserver = () => {
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    if (!('IntersectionObserver' in window) || !trigger) return;

    observer = new IntersectionObserver(requestUpdate, {
      root: null,
      threshold: [0, 1]
    });
    observer.observe(trigger);
  };

  const setupResizeObserver = () => {
    if (resizeObserver) {
      resizeObserver.disconnect();
      resizeObserver = null;
    }

    if (!('ResizeObserver' in window)) return;

    resizeObserver = new ResizeObserver(() => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(refresh, 100);
    });

    const { announcement, header } = getHeaderSections();
    const toolbar = getToolbar();
    [announcement, header, toolbar, trigger].forEach((element) => {
      if (element) resizeObserver.observe(element);
    });
  };

  const init = () => {
    trigger = document.querySelector(triggerSelector);

    if (!trigger) {
      setHidden(false);
      document.body.classList.remove(enabledClass);
      if (observer) observer.disconnect();
      if (resizeObserver) resizeObserver.disconnect();
      return;
    }

    document.body.classList.add(enabledClass);
    refresh();
    setupObserver();
    setupResizeObserver();
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('collection-header-scroll:refresh', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(refresh, 100);
  });

  init();
})();
